<div class="bg-header-background outline-[1.25rem] outline outline-header-background text-header-foreground">
    <ng-content></ng-content>
</div><br>
